import _ from 'lodash'
import ShopService from '../../services/shop.service'
import importService from '../../services/import.service'
import reportService from '../../services/report.service'

export const shop = {
  namespaced: true,
  state: {
    allShops: [],
    activeShops: [],
    applicableImportTypes: [],
    applicableReportTypes: []
  },
  getters: {
    getApplicableImportTypes: state => {
      return state.applicableImportTypes
    }
  },
  actions: {
    fetchShopList ({ commit }) {
      return ShopService.getShopList().then(
        response => {
          if (response.data.Status) {
            commit('updateShops', response.data.Object.allShops)
          } else {
            commit('updateShops', [])
          }
          return Promise.resolve(response.data)
        },
        error => {
          commit('updateShops', [])
          return Promise.reject(error)
        }
      )
    },
    fetchApplicableImportTypes ({ commit }) {
      return importService.getApplicableImportTypes().then(
        response => {
          if (response.data.Status) {
            commit('updateApplicableImportTypes', response.data.Object.applicableImportTypes)
          } else {
            commit('updateApplicableImportTypes', [])
          }
          return Promise.resolve(response.data)
        },
        error => {
          commit('updateApplicableImportTypes', [])
          return Promise.reject(error)
        }
      )
    },
    fetchApplicableReportTypes ({ commit }) {
      return reportService.getApplicableReportTypes().then(
        response => {
          if (response.data.Status) {
            commit('updateApplicableReportTypes', response.data.Object.applicableReportTypes)
          } else {
            commit('updateApplicableReportTypes', [])
          }
          return Promise.resolve(response.data)
        },
        error => {
          commit('updateApplicableReportTypes', [])
          return Promise.reject(error)
        }
      )
    }
  },
  mutations: {
    updateShops (state, shopList) {
      state.allShops = shopList
      state.activeShops = _.filter(shopList, function (shop) {
        return shop.ActiveStatus
      })
    },
    updateApplicableImportTypes (state, applicableImportList) {
      state.applicableImportTypes = applicableImportList
    },
    updateApplicableReportTypes (state, applicableReportList) {
      state.applicableReportTypes = applicableReportList
    }
  }
}
